import { render } from "./Socks_3_back.vue?vue&type=template&id=41b8d650"
import script from "./Socks_3_back.vue?vue&type=script&lang=js"
export * from "./Socks_3_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__